'use client';
import { motion, useAnimate } from 'framer-motion';
import { useEffect, useState } from 'react';

function Loading() {
  const [scope, animate] = useAnimate();
  const [show, setShow] = useState(true);

  useEffect(() => {
    const animateLoader = async () => {
      animate(
        [
          ['.x1', { pathLength: 1, pathOffset: 1 }],
          ['.x2', { pathLength: 1, pathOffset: 1 }],
        ],
        { duration: 0.2, ease: 'linear', repeat: Infinity }
      );
    };

    animateLoader();

    // Set a timeout to hide the loader after 3 seconds
    const timer = setTimeout(() => {
      setShow(false);
    }, 500);

    // Cleanup the timer if the component unmounts
    return () => clearTimeout(timer);
  }, [animate]);

  if (!show) return null;

  return (
    <div className='fixed inset-0 z-[10000] flex items-center justify-center bg-white'>
      <svg
        className=''
        ref={scope}
        width='140.033241mm'
        height='120.361317mm'
        viewBox='-15 0 93.033241 70.361316'
      >
        <motion.path
          className='x1'
          initial={{ pathLength: 0.05, pathOffset: 0.05 }}
          d='M 10,10 L 50,50'
          stroke='#13d0e1'
          strokeWidth='2'
        />
        <motion.path
          className='x2'
          initial={{ pathLength: 0.05, pathOffset: 0.05 }}
          d='M 50,10 L 10,50'
          stroke='#FE2A53'
          strokeWidth='2'
        />
      </svg>
    </div>
  );
}

export default Loading;
